import PropTypes from 'prop-types';
import React, {Component} from 'react';

import {events} from 'lib';
import session from 'services/sessionService';

import PoolApi from 'api/pool';
import TruBlueApi from 'api/truBlue';
import customerApi from 'api/customer';
import Customer from 'models/customer';

import {truBlueStatus, countries, truBlueMemberIDRanges, productTypes} from 'helpers/constants';

import {Col, Row} from 'components';
import {Button} from 'components/layout';
import {Input} from 'components/forms';
import TruBlueModal from './trublue/truBlueModal';
import TruBlueAssignSystem from './trublue/truBlueAssignSystem';
import {Creatable} from 'react-select';
import ValidationGroup, {isValidEmail} from 'helpers/validation';
import {isProductTruBlue} from 'helpers/truBlue';

import {FormattedMessage, injectIntl} from 'react-intl';
import moment from 'moment';

class TruBlueRegistration extends Component {

  static propTypes = {
    customer: PropTypes.object,
    dealer: PropTypes.object,
    products: PropTypes.array,
    setCustomer: PropTypes.func,
    onClose: PropTypes.func,
    onSuccess: PropTypes.func,
    intl: PropTypes.any,
  };

  state = {
    pools: [],
    products: this.props.products,
    customer: this.props.customer.clone(),
    customerEmails: [],
    email: null,
    invalidEmail: false,
    selectedPools: [],
  };

  componentWillMount() {
    this.group = new ValidationGroup(this.save);
    this.setCustomerEmails(this.props.customer);

    PoolApi.getList(this.props.customer.id).then(pools => {
      this.setState({
        pools: pools,
        visible: true,
      });
    }).catch(err => {
      console.error(err);
      events.publish('error.user', {message: 'Failed to get pools.'});
    });
  };

  setCustomerEmails = customer => {
    let customerEmails = customer.customerContacts.reduce((emails, contact) => {
      if (contact.email) {
        emails.push({label: contact.email, value: contact.email});
      }
      return emails;
    }, []);

    this.setState({
      customerEmails,
      email: customerEmails.length > 0 ? customerEmails[0] : null,
    });

  };

  save = () => {
    let {onClose, onSuccess, dealer} = this.props;
    let {formatMessage} = this.props.intl;
    let {customer, email, invalidEmail, selectedPools, products} = this.state;

    if (invalidEmail) {
      this.emailSelect.focus();
    } else {
      onClose();

      let pools = selectedPools.map(p => {
        let isSanitizerTruBlue = isProductTruBlue(products, productTypes.sanitizer, dealer, p.chemicalBaseTypeID, p.sanitizer);
        let isMaintOxidizerTruBlue = isProductTruBlue(products, productTypes.maintOxidizer, dealer, p.chemicalBaseTypeID, p.maintOxidizer);
        let isPrevAlgicideTruBlue = isProductTruBlue(products, productTypes.prevAlgicide, dealer, p.chemicalBaseTypeID, p.prevAlgicide);
        let isMaintClarifierTruBlue = p.usingOptimizerPlus ||
          isProductTruBlue(products, productTypes.maintClarifier, dealer, p.chemicalBaseTypeID, p.maintClarifier);

        p.hasAllTruBlueProducts = isSanitizerTruBlue && isMaintOxidizerTruBlue && isPrevAlgicideTruBlue && isMaintClarifierTruBlue;
        return p;
      });

      TruBlueApi.registerCustomer(customer, pools, email && email.value)
        .then(res => {
          if (!res.success) {
            throw new Error(`${formatMessage({id: 'trublue.modal.registration.failed'})}`);
          }

          for (let pool of this.state.pools) {
            session.deletePool(pool);
          }

          this.props.setCustomer(Customer.fromApiFormat(res.data));
          onSuccess();
        })
        .catch(err => {
          console.error(err);
          events.publish('error.user', {message: `${formatMessage({id: 'trublue.modal.registration.failed'})}`});
        });
    }
  };


  onPoolSelectionChange = (pool, isBeingSelected) => {
    let {selectedPools} = this.state;

    if (isBeingSelected) {
      selectedPools.push(pool);
      this.setState({selectedPools});
      return;
    }

    this.setState({selectedPools: selectedPools.filter(p => p.id !== pool.id)});
  };

  emailChange = value => {
    this.setState({
      email: value,
      invalidEmail: false,
    });
  };

  isValidNewOption = option => option && (option.label || '').trim().length > 0 ?
    isValidEmail(option.label) :
    false;

  optionRenderer = item => <span title={item.label}>{item.label}</span>;

  onCustomerChange = e => {
    let customer = this.state.customer;
    let keys = Object.keys(customer);

    if (keys.includes(e.key)) {
      customer[e.key] = e.value;
    }

    this.setState({customer});
  };


  validateMemberID = () => {
    let {dealer} = this.props;
    let {formatMessage} = this.props.intl;
    let {customer} = this.state;
    let memberIDRange = dealer.country !== countries.CA ?
      truBlueMemberIDRanges.US :
      truBlueMemberIDRanges.CA_EN.concat(truBlueMemberIDRanges.CA_FR);
    let {0: min, [memberIDRange.length - 1]: max} = memberIDRange;

    if (!(customer.id && customer.truBlueMemberID)) {
      this.setState({truBlueMemberErrorMessage: ''});
      return;
    }

    if (customer.truBlueMemberID.toString().length !== 9) {
      this.setState({truBlueMemberErrorMessage: formatMessage({id: 'trublue.modal.membership.invalidid'})});
      return;
    }

    if (customer.truBlueMemberID < min || customer.truBlueMemberID > max) {
      this.setState({truBlueMemberErrorMessage: formatMessage({id: 'trublue.modal.membership.invalidrange'})});
      return;
    }

    customerApi.checkUniqueTruBlueMemberID(customer.id, customer.truBlueMemberID)
      .then(existing => {
        this.setState({truBlueMemberErrorMessage: existing ? formatMessage({id: 'trublue.modal.membership.duplicateid'}) : ''});
      });
  };

  validateSubmit = () => {
    let {email} = this.state;

    if (email && email.value && this.emailSelect && !isValidEmail(email.value)) {
      this.setState({invalidEmail: true});
    }

    this.group.validate();

  };

  enabledSubmit = () => {
    let {customer, email, truBlueMemberErrorMessage, invalidEmail, selectedPools} = this.state;
    let checkedPoolsNumber = selectedPools.length;

    return !invalidEmail && customer.truBlueMemberID && !truBlueMemberErrorMessage && checkedPoolsNumber >= 1;
  };

  render() {
    let {pools, products, email, customer, truBlueMemberErrorMessage, customerEmails, invalidEmail} = this.state;
    let {onClose} = this.props;
    let {formatMessage, formatNumber} = this.props.intl;
    let memberIDHasError = !!truBlueMemberErrorMessage;

    return <TruBlueModal onClose={onClose}>
      <div className='trublue-modal__section'>
        <h1 className='trublue-modal__section-title'>
          <FormattedMessage id='trublue.registration.year'
                            values={{year: moment().year()}}/>
        </h1>
        <p className='trublue-modal__section-subtitle'><FormattedMessage id='trublue.modal.membership.subtitle'/></p>
        <div className='truBlue-membership'>
          <Row>
            <Col md={4}>
              <Input editMode
                     label={formatMessage({id: 'general.trublue.memberID'})}
                     dataKey='truBlueMemberID'
                     type='number'
                     value={customer.truBlueMemberID}
                     validate={() => !memberIDHasError}
                     onBlur={this.validateMemberID}
                     error={memberIDHasError}
                     errorMessage={truBlueMemberErrorMessage}
                     required

                     dataChanged={this.onCustomerChange}
                     maxLength='5'
                     group={this.group}/>
            </Col>
            <Col md={4}>
              <div className='form-group'>
                <label><FormattedMessage id='general.email'/></label>
                <Creatable
                  ref={r => this.emailSelect = r}
                  name='email'
                  options={customerEmails}
                  value={email}
                  autosize={false}
                  placeholder=''
                  className={`trublue-email-select ${invalidEmail ? 'trublue-email-select-error' : '' }`}
                  isValidNewOption={this.isValidNewOption}
                  onChange={this.emailChange}
                  optionRenderer={this.optionRenderer}
                  inputProps={{'maxLength': 50, className: `${invalidEmail ? 'error' : '' }`}}
                  noResultsText={formatMessage({id: 'trublue.modal.membership.noemailoptions'})}
                  promptTextCreator={label => `${formatMessage({id: 'trublue.modal.membership.createemailoption'})} '${label}'`}/>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className='trublue-modal__section'>
        <h1 className='trublue-modal__section-title'>
          <FormattedMessage id='trublue.modal.systemselection.title'/>
        </h1>
        <p className='trublue-modal__section-subtitle'>
          <FormattedMessage id='trublue.modal.systemselection.firstsubtitle'/>
          <br/>
          <FormattedMessage id='trublue.modal.systemselection.secondsubtitle'/>
        </p>
        <div className='truBlue-selection'>
          {pools.filter(x => x.truBlueStatus !== truBlueStatus.Ineligible).map(pool =>
            <TruBlueAssignSystem pool={pool.clone()}
                                 key={pool.id}
                                 products={products}
                                 ref={'pool-' + pool.id}
                                 register={this.register}
                                 unregister={this.unregister}
                                 dealer={this.props.dealer}
                                 formatNumber={formatNumber}
                                 formatMessage={formatMessage}
                                 onPoolSelectionChange={this.onPoolSelectionChange}/>)}
        </div>
      </div>
      <div className='trublue-modal__controls'>
        <Button default
                onClick={onClose}
                style={{marginRight: 20}}><FormattedMessage id='general.cancel'/></Button>
        <Button primary
                onClick={this.validateSubmit}
                disabled={!this.enabledSubmit()}><FormattedMessage id='general.register'/></Button>
      </div>
    </TruBlueModal>;
  }
}


export default injectIntl(TruBlueRegistration);
